import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = ["onClick"]

import { computed, ref } from "vue";
import BottomSheet from "@/components/Modals/BottomSheet.vue";
import EditCategories from "@/components/Form/EditCategories.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import MediumText from "@/components/Texts/MediumText.vue";
import SmallText from "@/components/Texts/SmallText.vue";
import ExtraSmallText from "@/components/Texts/ExtraSmallText.vue";
import InputTextarea from "@/components/Form/Common/InputTextarea.vue";
import PrimaryButton from "@/components/Form/Common/PrimaryButton.vue";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";
import SecondaryButton from "@/components/Form/Common/SecondaryButton.vue";
import ErrorText from "@/components/Texts/ErrorText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCustomActions',
  props: {
    dialogId: {}
  },
  setup(__props: any) {

const props = __props;

const gameStore = useGameStore();

const textValue = ref("");

const onSubmit = () => {
  gameStore.addCustomAction(textValue.value);
  if (!errorAction.value) {
    textValue.value = "";
  }
};

const customActions = computed(() => {
  return gameStore.localPlayersActions;
});

const errorAction = computed(() => {
  return gameStore.errors.find((error) => error.path.includes("actionCustom"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "out-side-closable": true,
    "all-draggable": false,
    "dialog-id": props.dialogId
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrimaryLabel, {
          text: "Ajouter une action pour la partie",
          class: "mb-2 text-left"
        }),
        _createVNode(ExtraSmallText, {
          class: "text-custom-lightGray text-left",
          text: "Personne ne pourra voir ses actions en dehors de vous.\n          Elles seront ajoutées en priorités par rapport aux actions des différentes\n          catégories séléctionnées."
        }),
        _createVNode(PrimaryLabel, {
          text: "Action :",
          class: "text-left"
        }),
        _createVNode(InputTextarea, {
          name: "action",
          placeholder: "Julie fais 3 pompes ou boit 4 gorgées.",
          id: "action",
          is_required: true,
          modelValue: textValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textValue).value = $event))
        }, null, 8, ["modelValue"]),
        (errorAction.value)
          ? (_openBlock(), _createBlock(ErrorText, {
              key: 0,
              text: errorAction.value.message,
              class: "mt-2 text-left"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(PrimaryButton, {
          onClick: onSubmit,
          label: "Ajouter"
        }),
        _hoisted_2,
        _createVNode(SecondaryButton, {
          onClick: _unref(gameStore).deleteAllCustomActions,
          label: "Tous supprimer"
        }, null, 8, ["onClick"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customActions.value, (customAction, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: customAction.description,
            class: "grid grid-cols-12"
          }, [
            _createVNode(ExtraSmallText, {
              text: customAction.description,
              class: "col-span-10 text-left"
            }, null, 8, ["text"]),
            _createElementVNode("i", {
              class: "bi bi-trash3 col-span-2 text-white text-right",
              onClick: ($event: any) => (_unref(gameStore).deleteCustomAction(index))
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})